<section class="widget-wrapper">
  <ng-template #widgetContent></ng-template>
</section>
